import { render, staticRenderFns } from "./PublicationsAndComments.vue?vue&type=template&id=14dbabe8&"
import script from "./PublicationsAndComments.vue?vue&type=script&lang=js&"
export * from "./PublicationsAndComments.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsAndComments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports